export default "__VITE_PUBLIC_ASSET__f6cf977e__"